import { createRouter, createWebHistory } from 'vue-router';
import { handleHotUpdate, routes } from 'vue-router/auto-routes';
import setBodyClasses from '../middleware/set-body-classes.global';
import resetBackground from '../middleware/reset-background.global';
import { moduleLoadingErrorHandler } from '@ilteducation/web-error-handling';

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: routes,
});

router.beforeEach((to, from, next) => {
    setBodyClasses(to);
    resetBackground(to, from);
    next();
});

router.onError(moduleLoadingErrorHandler(import.meta.env.BASE_URL));

export default router;

// This will update routes at runtime without reloading the page
if (import.meta.hot) {
    handleHotUpdate(router);
}
